import Modal from '@components/v2/ui/Modal/Modal';
import Typography from '@components/v2/ui/Typography/Typography';
import LangEnum from '../../../../../../../lang/LangEnum';
import { OrderConditionsTestIds } from '../../../../../../../utils/testIds/OrderConditions.testIds';
import { useTranslation } from '../../../../../../translation/TranslationContext';

export interface OrderConditionApplyToAllState {
  isOpen: boolean;
  isSaving?: boolean;
  onApplyToCurrent: () => void;
  onApplyToAll: () => void;
}

const OrderConditionApplyToAllModal = ({
  isOpen,
  isSaving,
  onApplyToCurrent,
  onApplyToAll,
}: OrderConditionApplyToAllState) => {
  const { translate } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      size="compact"
      isDismissable={!isSaving}
      testId={OrderConditionsTestIds.APPLY_TO_ALL_MODAL}
      onClose={onApplyToCurrent}
      header={{ title: LangEnum.GLOBAL_ORDER_SPLITS }}
      footer={{
        secondaryAction: { label: LangEnum.GLOBAL_CANCEL_LABEL, onClick: onApplyToCurrent },
        primaryAction: {
          label: LangEnum.GLOBAL_CONTINUE,
          onClick: onApplyToAll,
          isLoading: isSaving,
        },
      }}
    >
      <Typography variant="body2">{translate(LangEnum.APPLY_TO_ALL_CONDITIONS)}</Typography>
    </Modal>
  );
};

export default OrderConditionApplyToAllModal;
